<template>
  <RevCard class="!bg-surface-brand-hi flex flex-col p-16">
    <section>
      <header class="mb-8 flex items-start justify-between">
        <p class="body-2 flex items-center gap-8">
          <IconCheckInCircleFilled class="text-static-brand-mid" />
          <span>{{ name }}</span>
        </p>
        <RevButtonBase
          v-if="removable"
          class="body-2 text-static-default-low"
          data-qa="delete-tradein-offer-button"
          data-test="delete-tradein-offer-button"
          @click="deleteAcceptedOffer"
        >
          {{ i18n(translations.delete) }}
        </RevButtonBase>
      </header>
      <div class="mb-16 flex flex-col gap-4">
        <div class="flex flex-col">
          <span class="heading-1 text-static-brand-mid">
            {{ i18n.price(price) }}
          </span>
          <span class="body-2 text-static-brand-mid">
            {{ i18n(translations.tradeinValue) }}
          </span>
        </div>
      </div>
      <p v-if="!hasPositivePrice" class="body-2 mb-10">
        {{ i18n(translations.recycleForFree) }}
      </p>
      <ul class="body-2 text-static-default-hi flex list-none flex-col gap-4">
        <li v-if="hasPositivePrice" class="flex items-start gap-8">
          <IconSparkles class="shrink-0" size="small" />
          <span> {{ i18n(translations.bestTimeToSell) }} </span>
        </li>
        <li v-if="hasPositivePrice" class="flex items-start gap-8">
          <IconLeaf class="shrink-0" size="small" />
          <span> {{ i18n(translations.circularity) }} </span>
        </li>
        <li class="flex items-start gap-8">
          <IconTruckExpress class="shrink-0" size="small" />
          <span> {{ i18n(translations.shipping) }} </span>
        </li>
      </ul>
    </section>
  </RevCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'
import { IconLeaf } from '@ds/icons/IconLeaf'
import { IconSparkles } from '@ds/icons/IconSparkles'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import { useTradeInApacOffer } from '~/scopes/tradein-apac/composables/useTradeInApacOffer'

import translations from './TradeInOffer.translations'

const props = defineProps<{
  name: string
  price: Price
  removable?: boolean
}>()

const { deleteAcceptedOffer } = useTradeInApacOffer()

const hasPositivePrice = computed(() => Number(props.price.amount) > 0)

const i18n = useI18n()
</script>
